<template>
    <div>
      <div class="card-header d-flex justify-content-center">
        <strong>
          Routing Solver run at {{ resultsTimestamp | formatDateTime }}
        </strong>
      </div>
      <div class="card-body mx-auto my-auto h-100">
        <div class="row h-100">
          <div class="d-flex flex-column col align-items-start justify-content-around">
            <solution-stat-card>
              <template #stat-name>Inspections Assigned:</template>
              <template #stat-value>
                {{ stats.numInspectionsAssigned }} / {{ totalInspections }} &nbsp;({{ percentInspectionsAssigned.toFixed(0) }}%)
              </template>
            </solution-stat-card>

            <solution-stat-card v-if="!isSimulation">
              <template #stat-name>Manually Assigned:</template>
              <template #stat-value>{{ stats.numInspectionsManuallyAssigned }}</template>
            </solution-stat-card>

            <solution-stat-card>
              <template #stat-name>Assigned By AI:</template>
              <template #stat-value>{{ numInspectionsAssignedByAI }}</template>
            </solution-stat-card>

            <solution-stat-card v-if="isSimulation">
              <template #stat-name>AI Accuracy:</template>
              <template #stat-value>{{ percentAccuracy.toFixed(0) }}% AI assignments matched actual</template>
            </solution-stat-card>
          </div>

          <div class="d-flex flex-column col align-items-start justify-content-around">
            <solution-stat-card>
              <template #stat-name>Reinspections:</template>
              <template #stat-value>
                {{ stats.numReinspections }}&nbsp;
                {{ isSimulation ? '' : ` (${stats.numReinspectionsManuallyAssigned} manually assigned)` }}
              </template>
            </solution-stat-card>

            <solution-stat-card>
              <template #stat-name>Reinspections Assigned Most Recent Active Previous Inspector:</template>
              <template #stat-value>{{ stats.numReinspectionsAssignedMostRecentInspector }}</template>
            </solution-stat-card>

            <solution-stat-card>
              <template #stat-name>Reinspections Assigned New Inspector By AI:</template>
              <template #stat-value>{{ numReinspectionsAssignedByAI }}</template>
            </solution-stat-card>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {sync} from 'vuex-pathify'
import SolutionStatCard from '@/components/Dashboard/Views/InspectorRouting/SolutionStatCard.vue'

export default {
  components: {SolutionStatCard},
  computed: {
    isSimulation: sync('inspectorRouting/solverParams@isSimulation'),
    ...mapGetters({
      stats: 'inspectorRouting/stats',
      results: 'inspectorRouting/results',
      resultsTimestamp: 'inspectorRouting/resultsTimestamp'
    }),
    totalInspections() {
      return this.results.length
    },
    percentInspectionsAssigned() {
      return (this.stats.numInspectionsAssigned / this.totalInspections * 100)
    },
    numInspectionsAssignedByAI() {
      return (this.stats.numInspectionsAssigned - this.stats.numInspectionsManuallyAssigned - this.stats.numReinspectionsAssignedMostRecentInspector)
    },
    percentAccuracy() {
      return this.stats.numMatchingAssignments / this.stats.numInspectionsAssigned * 100
    },
    numReinspectionsAssignedByAI() {
      return (this.stats.numReinspectionsAssigned - this.stats.numReinspectionsManuallyAssigned - this.stats.numReinspectionsAssignedMostRecentInspector)
    }
  }
}
</script>
